import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.99967 11.3327H12.6663M5.99967 7.99935H12.6663M5.99967 4.66602H12.6663M3.33431 11.3327V11.334L3.33301 11.334V11.3327H3.33431ZM3.33431 7.99935V8.00068L3.33301 8.00065V7.99935H3.33431ZM3.33431 4.66602V4.66735L3.33301 4.66732V4.66602H3.33431Z",
      stroke: "#94A3B8",
      "stroke-width": "1.4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }